module.exports = __webpack_public_path__ + "static/img/store_36.324f99a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/store_36.jpg
// module id = H/66
// module chunks = 1